import {Grid, GridItem, Heading, Image, Link, Text} from "@chakra-ui/react"
import {FaEnvelope} from "react-icons/fa"
import {useEffect, useState} from "react";

export default function SocialMediaGrid({data, order = true, styles}) {
    const [filteredData, setFilteredData] = useState(data);
    let style = {
        nameColor: "color4",
        linkColor: "color5",
        ...styles,
    }

    let columnCount;
    if (data.length === 6) {
        columnCount = 3;
    } else if (data.length % 4 === 0 || data.length % 5 === 1) {
        columnCount = 4;
    } else {
        columnCount = 5;
    }

    useEffect(() => {
        if (order) {
            const sortedData = data.sort((a, b) => {
                if (a.ln < b.ln) {
                    return -1;
                }
                if (a.ln > b.ln) {
                    return 1;
                }
                return 0;
            })
            setFilteredData([...sortedData]);
        }
    }, [])


    return (
        <Grid
            templateColumns={["repeat(2, 1fr)", "repeat(3, 1fr)", `repeat(${columnCount}, 1fr)`]}
            mt={"30px"}
            width={"100%"}
            columnGap={"10px"}
            rowGap={"50px"}
        >
            {filteredData.map(d => {
                return (
                    <GridItem key={d.fn + d.ln}


                    >
                        {d.img === undefined || d.img === "" ? (
                            <Image
                                alt={d.fn + " " + d.ln}
                                maxWidth={"150px"}
                                src={"https://assets.crfconnect.com/meetings/cto2023/page-content/Portrait-3.jpg"}

                            />
                        ) : (
                            <Image maxWidth={"150px"} src={d.img} alt={d.fn + " " + d.ln}

                            />
                        )}
                        {d.email !== undefined && (
                            <Link href={"mailto:" + d.email} color={style.linkColor}>
                                <FaEnvelope/>
                            </Link>
                        )}

                        <Heading as={"h4"} fontSize={"20px"} mt={"10px"} color={style.nameColor}
                                 cursor={d.link ? "pointer" : "auto"}
                                 onClick={() => {
                                     if (d.link != undefined) {
                                         console.log("click?", d.link)
                                         window.open(d.link, "_blank")
                                     }
                                 }}
                        >
                            {d.fn} {d.ln}
                            <br/>
                        </Heading>
                        {d.bio !== undefined && (
                            <Text
                                color={style.nameColor}
                                maxW={"150px"}
                                fontSize={"14px"}
                                lineHeight={"16px"}
                                mt={"10px"}
                            >
                                {d.bio}
                            </Text>
                        )}
                        {d.twitter !== undefined && (
                            <Link href={"https://twitter.com/" + d.twitter} target="_blank" color={style.linkColor}>
                                @{d.twitter}
                            </Link>
                        )}
                    </GridItem>
                )
            })}
        </Grid>
    )
}
